import {
  Button,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  useDisclosure,
  UseDisclosureReturn,
  VisuallyHidden,
} from '@chakra-ui/react';
import { PropsWithChildren } from 'react';

import { DotsIcon } from '@sphere/icons';
import { rem } from 'polished';
import { useUITranslation } from '../../context/TranslationProvider';

type Props = UseDisclosureReturn & {
  isActive?: boolean;
};

export const ActionDrawer = ({ children, isActive, ...rest }: PropsWithChildren<Props>) => {
  const { t } = useUITranslation();
  const { isOpen, onOpen, onClose } = useDisclosure(rest);

  return (
    <>
      <Button
        variant="secondary"
        rounded="radius.8"
        width="auto"
        justifyContent="space-between"
        onClick={onOpen}
        border={isActive ? '1px solid black' : undefined}
      >
        <DotsIcon color="gray.1" boxSize={rem(20)} mr="space.6" />
        <VisuallyHidden>{t('common.drawers.actions.trigger-button.label')}</VisuallyHidden>
      </Button>
      <Drawer isOpen={isOpen} onClose={onClose} placement="bottom">
        <DrawerOverlay
          background="rgba(34, 34, 34, 0.4)"
          backdropFilter="auto"
          backdropBlur={rem(4)}
        />
        <DrawerContent bg="blackBg" borderTopRadius="radius.12">
          <DrawerCloseButton size="lg" />

          <DrawerHeader mt="space.24" fontWeight="200" fontSize="2xl">
            {t('common.drawers.actions.trigger-button.label')}
          </DrawerHeader>

          <DrawerBody>{children}</DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
};
